import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MsCallService } from './ms-call.service';
import { environment } from '../../environments/environment';
import { CommonResponse } from '../shared/models/common-response';
import { Observable } from 'rxjs';
import { SessionService } from './session.service';
import { EncryptionUtil } from './encryption-util';
import { ContextService } from './context.service';
import { SignalService } from './signals/signal.service';
import { AccountFormatService } from './account-format.service';

@Injectable({
  providedIn: 'root'
})
export class OnboardingProductsService extends MsCallService {
  constructor(
    http: HttpClient,
    sessionService: SessionService,
    encryptService: EncryptionUtil,
    signalService: SignalService,
    contextService: ContextService,
    accountFormatService: AccountFormatService
  ) {
    super(http, sessionService, encryptService, signalService, contextService, accountFormatService);
    this.servicesUrl = environment.SERVICES.HOST + environment.SERVICES.BASE_PATH;
    this.privateServicesUrl = environment.SERVICES.HOST_PRIVATE + environment.SERVICES.BASE_PATH;
  }

  msCallManager(body: any, path: string, ignoreSessionHeaders = false, isPrivate = false): Observable<CommonResponse> {
    return super.msCall(body, path, ignoreSessionHeaders, isPrivate);
  }

  /*
    Calls Services
   */


  public getClientAdmissionEvaluate(body: any) {
    const urlEndPoint = environment.SERVICES.CAE.URI;
    console.log('Llamando a ', urlEndPoint);
    console.log('Con body:', body);
    return this.msCallManager(body, urlEndPoint);
  }

  public getEmailValidate(body: any) {
    const urlEndPoint = environment.SERVICES.EMAIL_VALIDATE.URI;
    console.log('Llamando a ', urlEndPoint);
    console.log('Con body:', body);
    return this.msCallManager(body, urlEndPoint);
  }

  public getIsCTSEmployee(body: any) {
    const urlEndPoint = environment.SERVICES.IS_CTS_EMPLOYEE.URI;
    return this.msCallManager(body, urlEndPoint);
  }

  public getReqManagerGet(body: any) {
    const urlEndPoint = environment.SERVICES.REQUEST_MANAGER_GET.URI;
    console.log('Llamando a ', urlEndPoint);
    console.log('Con body:', body);
    const response = this.msCallManager(body, urlEndPoint);
    return response;
  }


  public getReqManagerCreate(body: any) {
    const urlEndPoint = environment.SERVICES.REQUEST_MANAGER_CREATE.URI;
    console.log('Llamando a ', urlEndPoint);
    console.log('Con body:', body);
    return this.msCallManager(body, urlEndPoint);
  }

  public getAddressManagerCreate(body: any) {
    const urlEndPoint = environment.SERVICES.ADDRESS_MANAGER_CREATE.URI;
    console.log('Llamando a ', urlEndPoint);
    console.log('Con body:', body);
    return this.msCallManager(body, urlEndPoint);
  }


  public getLaborManagerCreate(body: any) {
    const urlEndPoint = environment.SERVICES.LABOR_MANAGER_CREATE.URI;
    console.log('Llamando a ', urlEndPoint);
    console.log('Con body:', body);
    return this.msCallManager(body, urlEndPoint);
  }

  public getcurrencyType(body: any) {
    const urlEndPoint = environment.SERVICES.CONFIG_REQUEST_MANAGER.URI;
    console.log('Llamando a ', urlEndPoint);
    console.log('Con body:', body);
    return this.msCallManager(body, urlEndPoint);
  }

  public getNationalityManagerCreate(body: any) {
    console.log('Data que se está enviando', body);
    const urlEndPoint = environment.SERVICES.NATIONALITY_MANAGER_CREATE.URI;
    console.log('Llamando a ', urlEndPoint);
    console.log('Con body:', body);
    return this.msCallManager(body, urlEndPoint);
  }

  public getFinancialDataManagerCreate(body: any) {
    const urlEndPoint = environment.SERVICES.FINANCIAL_DATA_MANAGER_CREATE.URI;
    console.log('Llamando a ', urlEndPoint);
    console.log('Con body:', body);
    return this.msCallManager(body, urlEndPoint);
  }

  public getTermsAndConditionsManagerCreate(body: any) {
    console.log('Data que se está enviando', body);
    const urlEndPoint = environment.SERVICES.TERMS_AND_CONDITIONS_MANAGER_CREATE.URI;
    console.log('Llamando a ', urlEndPoint);
    console.log('Con body:', body);
    return this.msCallManager(body, urlEndPoint);
  }

  public getPassiveDocumentCreation(body: any) {
    const urlEndPoint = environment.SERVICES.PASSIVE_DOCUMENT_CREATION.URI;
    console.log('Llamando a ', urlEndPoint);
    console.log('Con body:', body);
    return this.msCallManager(body, urlEndPoint);
  }

  public getCustomerChallengeGenerate(body: any) {
    const urlEndPoint = environment.SERVICES.CUSTOMER_CHALLENGE_GENERATE.URI;
    console.log('Llamando a ', urlEndPoint);
    console.log('Con body:', body);
    return this.msCallManager(body, urlEndPoint);
  }

  public getCheckToken(body: any) {
    const urlEndPoint = environment.SERVICES.CHECK_TOKEN.URI;
    console.log('Llamando a ', urlEndPoint);
    console.log('Con body:', body);
    return this.msCallManager(body, urlEndPoint);
  }

  public getPasswordCreate(body: any) {
    const urlEndPoint = environment.SERVICES.PASSWORD_CREATE.URI;
    console.log('Llamando a ', urlEndPoint);
    console.log('Con body:', body);
    return this.msCallManager(body, urlEndPoint);
  }

  public getCreateUserAccount(body: any) {
    const isPrivate = this.contextService.isExecutiveMode();
    const isCallcenter = this.sessionService.isCallCenter === 'true';
    const urlEndPoint = isPrivate && !isCallcenter ?
    environment.SERVICES.CREATE_USER_ACCOUNT_PRIVATE.URI :
    environment.SERVICES.CREATE_USER_ACCOUNT.URI;
    console.log('Llamando a ', urlEndPoint);
    console.log('Con body:', body);
    return this.msCallManager(body, urlEndPoint, false, isPrivate);
  }

  public getCreateProduct(body: any) {
    const isPrivate = this.contextService.isExecutiveMode();
    const isCallcenter = this.sessionService.isCallCenter === 'true';
    const urlEndPoint = isPrivate && !isCallcenter ?
      environment.SERVICES.COG_PRIVATE.URI :
      environment.SERVICES.COG.URI;
    console.log('Llamando a ', urlEndPoint);
    console.log('Con body:', body);
    return this.msCallManager(body, urlEndPoint, false, isPrivate);
  }

  public getCigo(body: any) {
    const urlEndPoint = environment.SERVICES.CIGO.URI;
    console.log('Llamando a ', urlEndPoint);
    console.log('Con body:', body);
    return this.msCallManager(body, urlEndPoint);
  }

  public getPio() {
    const urlEndPoint = environment.SERVICES.PIO.URI;
    console.log('Llamando a ', urlEndPoint);
    return this.msCallManager({}, urlEndPoint);
  }

  public getClientStatePassword() {
    const urlEndPoint = environment.SERVICES.CLIENT_STATE_PASSWORD_GET.URI;
    console.log('Llamando a ', urlEndPoint);
    return this.msCallManager({}, urlEndPoint);
  }

  public getDocumentSignature(body: any) {
    const isPrivate = this.contextService.isExecutiveMode();
    const isCallcenter = this.sessionService.isCallCenter === 'true';
    const urlEndPoint = isPrivate && !isCallcenter ?
      environment.SERVICES.DOCUMENT_SIGNATURE_PRIVATE.URI :
      environment.SERVICES.DOCUMENT_SIGNATURE.URI;
    console.log('Llamando a ', urlEndPoint);
    console.log('Con body:', body);
    return this.msCallManager(body, urlEndPoint, false, isPrivate);
  }

  public getTri(body: any) {
    const urlEndPoint = environment.SERVICES.TRI.URI;
    console.log('Llamando a ', urlEndPoint);
    console.log('Con body:', body);
    return this.msCallManager(body, urlEndPoint);
  }

  public getTre(body: any) {
    const urlEndPoint = environment.SERVICES.TRE.URI;
    console.log('Llamando a ', urlEndPoint);
    console.log('Con body:', body);
    return this.msCallManager(body, urlEndPoint);
  }

  public getValidateSession(body: any) {
    const urlEndPoint = environment.SERVICES.VALIDATE_SESSION.URI;
    console.log('Llamando a ', urlEndPoint);
    console.log('Con body:', body);
    return this.msCallManager(body, urlEndPoint, true);
  }

  /*
    Others
    This is for making work the Cronograma de Pagos according to the way they designed it
    That means this needs to be changed
   */

  makeHeaders() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'version': '1.0',
        'channel': environment.accountOpeningParams.channel,
        'country': 'PE',
        'commerce': 'Banco'
      })
    };
  }
}
